// Чужое внимание чистыми функциями: без стора и DOM, чтобы юнит- и e2e-тесты могли их импортировать.
export const ATTENTION_HOLD_MS = 10_000;
export type Attention = { who: string; name: string; color: string; label: boolean };
export type Fading = Map<string, Attention & { until: number }>;
type Someone = { profile_id: string; name: string; color: string; editing: string | null; dragging: string[]; selected: string[] };

/** Задача → чьё она внимание сейчас: карточка, руки, выделение; имя — на первой у каждого; первый занявший задачу побеждает. */
export function attentionOf(presence: Iterable<Someone>, me: string | undefined): Map<string, Attention> {
  const m = new Map<string, Attention>();
  for (const p of presence) {
    if (p.profile_id === me) continue;
    let labelled = false; // имя — на первой задаче, которая досталась этому человеку
    for (const id of new Set([...(p.editing ? [p.editing] : []), ...p.dragging, ...p.selected])) {
      if (m.has(id)) continue;
      m.set(id, { who: p.profile_id, name: p.name, color: p.color, label: !labelled });
      labelled = true;
    }
  }
  return m;
}

/** Шаг угасания: что пропало из живого набора — держать до until; что вернулось — забыть. Без изменений — та же карта. */
export function fadeStep(was: Map<string, Attention>, live: Map<string, Attention>, fading: Fading, until: number): Fading {
  const gone = [...was].filter(([id]) => !live.has(id));
  const back = [...fading.keys()].filter((id) => live.has(id));
  if (gone.length === 0 && back.length === 0) return fading;
  const next = new Map(fading);
  for (const [id, a] of gone) next.set(id, { ...a, until });
  for (const id of back) next.delete(id);
  return next;
}

/** Угасшие к моменту now — вон; без изменений — та же карта. */
export function dropExpired(fading: Fading, now: number): Fading {
  if (![...fading.values()].some((a) => a.until <= now)) return fading;
  return new Map([...fading].filter(([, a]) => a.until > now));
}

/** Живое поверх угасающего; имя у человека одно: если оно уже на живой задаче, угасающая остаётся без имени. */
export function mergeAttention(live: Map<string, Attention>, fading: Fading): Map<string, Attention> {
  if (fading.size === 0) return live;
  const named = new Set([...live.values()].filter((a) => a.label).map((a) => a.who));
  const m = new Map<string, Attention>();
  for (const [id, { until: _until, ...a }] of fading) m.set(id, { ...a, label: a.label && !named.has(a.who) });
  for (const [id, a] of live) m.set(id, a);
  return m;
}
